import React from 'react'
import { Box, Grid } from '@mui/material'
import { AppFilterPanel, filterPanelGridSx } from '@components'
import GroupingExportsTable from 'Pages/ReportsAlerts/ExportsGrouping/Table'
import DateRangeFilter from 'Pages/ReportsAlerts/ExportsGrouping/Filter'
import GroupingExportsModal from 'Pages/ReportsAlerts/ExportsGrouping/Modal'


export default function GroupingExportsContent() {

	return <>
		<AppFilterPanel>
			<Box sx={filterPanelGridSx(4)}>
				<DateRangeFilter/>
			</Box>
		</AppFilterPanel>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<GroupingExportsTable/>
			</Grid>
			<Grid item xs={12}>
				<GroupingExportsModal/>
			</Grid>
		</Grid>
	</>
}